import React from "react";
import "./stylesSportPerformanceTableRow.css";
import moneyFormatter from "../../../../utils/MoneyFormatter";

import SortIcon from "../../../../assets/icons/ic_sort.svg";

import avatar from "../../../../assets/icons/avatar.png";
import CashIcon from "../../../../assets/icons/ic_cash.png";
import CoinIcon from "../../../../assets/icons/ic_coin.png";
import { formatNumber } from "chart.js/helpers";

function SportPerformanceTableRow({ is_header_row, data, handleSort }) {
  if (data?.last_evaluated_key) return null;

  return (
    <div className={`table-row ${is_header_row ? "table-header-row" : ""}`}>
      <div className="cell-small">
        <p className="cell-label">{is_header_row ? "Date" : data?.date}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("date")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">{is_header_row ? "Action" : data?.action}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("action")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">{is_header_row ? "Details" : data?.details}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("details")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">{is_header_row ? "IP address" : data?.ip}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("ip")}
          />
        )}
      </div>
    </div>
  );
}

export default SportPerformanceTableRow;
